import HomePage from './custom-components/HomePage';
import { Route, Routes } from "react-router-dom";
import VolunteerPage from './custom-components/VolunteerPage';
import LoaderPage from './custom-components/LoaderPage';
import Starter from './custom-components/Starter';
import StandAloneOrgPage from './custom-components/StandaloneOrgPage';
import OrganizationView from './custom-components/OrganizationView';
import FirstSessionSignUp from './custom-components/FirstSkateSession';
import LearnMore  from 'custom-components/LearnMore';
import { ProgramsEvents } from 'custom-components/ProgramsEvents';


function App() {
  return (
    <Routes>
    
      <Route path='VolunteerSignUp' element={<HomePage />}/>
      <Route path="Home" element={<Starter />}/>
      <Route path='*' element={<LoaderPage />}/>
      <Route path='Volunteer' element={<VolunteerPage />}/>
      <Route path='OrganizationView' element={<OrganizationView />}/>
      <Route path='Organization' element={<StandAloneOrgPage />}/>
      <Route path='/' element={<LoaderPage />}/>
      <Route path='SkaterSignUp' element={<FirstSessionSignUp />}/>
      <Route path='LearnMore' element={<LearnMore />}/>
       <Route path='Programs' element={<ProgramsEvents />}/>

      
      </Routes>
  );
}

export default App;
